<template>
  <label class="t-file-upload">
    <div class="t-file-upload__area" v-if="dragAndDrop">
      <slot v-bind:file="newValue">
        <div class="content--centered">
          <t-icon boxed icon="cloud-upload-alt" class="mb-2" /><br>
          <span v-if="!newValue">Upload files</span>
          <span v-else>{{ newValue.name }}</span>
        </div>
      </slot>
    </div>

    <div class="t-file-upload__single" v-else>
      <slot v-bind:file="newValue">
        <t-icon boxed icon="cloud-upload-alt" />
        <span v-if="!newValue">Upload files</span>
        <span v-else>{{ newValue.name }}</span>
      </slot>
    </div>

    <input
      class="t-file-upload__element"
      type="file"
      id="t-file-upload"
      :accept="accept"
      :disabled="disabled"
      :multiple="multiple"
      @change="onFileChange"
    >
  </label>
</template>

<script>
import { TIcon } from '../TIcon';
import ValidatableMixin from '../../mixins/ValidatableMixin';

export default {
  name: 't-file-upload',

  mixins: [ValidatableMixin],

  props: {
    value: [Object, Function, window.File, Array],
    dragAndDrop: Boolean,
    accept: String,
    disabled: Boolean,
    multiple: Boolean,
  },

  data() {
    return {
      newValue: this.value,
    };
  },

  watch: {
    value(value) {
      this.newValue = value;
    },
  },

  methods: {
    onFileChange(event) {
      if (this.disabled) return;

      const value = event.target.files || event.dataTransfer.files;

      if (this.multiple) {
        if (value.length === 0) {
          this.newValue = [];
        }
        this.newValue = value;
      } else {
        // eslint-disable-next-line
        this.newValue = value[0];
      }

      this.$emit('input', this.newValue);
      this.$emit('change', this.newValue);
    },
  },

  components: {
    TIcon,
  },
};
</script>
